<div class="main-wrapper">
	<div class="main-content">
		<!-- global markup for header -->
		<header class="header">
			<div class="content">
				<div class="header__block row">
					<div class="header__arrow col image" (click)="BackToAdmin()"><img src="/assets/images/header/back-arrow.svg" alt="arrow" /><span style="color: white; font-size: 18px">חזרה</span></div>

					<div class="header__title col">הדפסות</div>
					<div class="header__burger col image">
						<!-- <img src="/assets/images/header/burger.svg" alt="burger"> -->
					</div>
				</div>
			</div>

			<div class="report-table__row">
				<div style="width: 99%; margin: auto"></div>
			</div>
		</header>

		<!-- shop return activity markup -->
		<section class="shop-activity" style="margin-top: 140px">
			<div class="flex-row">
				<!-- <div class="flex gap" *ngIf="(_device.isWebview$ | async) === false">
					<app-excel-button onlyEmit (clicked)="downloadExcel()"></app-excel-button>
				</div> -->
			</div>
			<div class="report-table__row" style="overflow-x: auto">
				<table class="report-table__table" cellspacing="0" style="margin: 0 auto; width: min(100%, 1000px)">
					<thead class="report-table__table-head">
						<tr>
							<th class="report-table__table-head-name" style="width: 80px">תעודה</th>
							<th class="report-table__table-head-name" style="width: 150px">לקוח</th>
							<th class="report-table__table-head-name" style="width: 70px">יצירה</th>
							<th class="report-table__table-head-name" style="width: 48px">הצג</th>
						</tr>
					</thead>
					<tbody class="report-table__table-body">
						<tr *ngFor="let b of allPrints$ | async" class="border-bottom-black">
							<td class="report-table__table-body-name">{{ b.TeudaNum }}</td>
							<td class="report-table__table-body-name">{{ b.ClientName }}</td>
							<td class="report-table__table-body-name">{{ b.PDFDate | appDate : 'short' }}</td>
							<td class="report-table__table-body-name">
								<div class="report-table__button">
									<a [href]="b.externalPDFLink" target="_blank">פתח</a>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</section>
	</div>
</div>
